// Shared framer-motion animation configs (hoisted to avoid re-allocating inline
// objects on every render).
const EASE = [0.22, 1, 0.36, 1];

export const FADE_UP = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: EASE },
};

export const SCALE_IN = {
    initial: { opacity: 0, scale: 0.97 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.8, delay: 0.15, ease: EASE },
};

export const FADE_UP_DELAYED = {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: 0.6, duration: 0.6 },
};
